import {ulid} from 'ulid';

export const createFlowId = () => ulid();
